import React from "react";
import { Form } from "react-bootstrap";
import { useField } from "formik";

const BCheckBox = ({ id, label, type,value, ...props }) => {
    const [field, meta] = useField(props);
    return (
        <Form.Group>
            <Form.Check
                {...field}
                {...props}
                required
                custom
                label={label}
                isInvalid={meta.error && meta.touched}
                isValid={!meta.error && meta.touched && !meta.touched && meta.error}
                type={type}
                feedback={meta.error}
                id={id}
                inline
                value={value}
            />
        </Form.Group>
    );
};

BCheckBox.defaultProps = {
    id: null,
    type: "checkbox",
};

export default BCheckBox;
